import React from "react";
import { Tooltip, Grid, IconButton } from "@mzc-pdc/ui";
import { IconClose, IconSave } from "@mzc-cloudplex/icons";
import i18n from "@lib/i18n";

const EditSubmitButtonGroup = ({ onClickClose, onClickSubmit, submitDisabled, submitPending }) => {
    return (
        <Grid item sx={{ display: `flex`, justifyContent: `flex-end`, gap: `4px`, mt: 0.5 }}>
            <Tooltip title={i18n.t(`common::label::Cancel`, `Cancel`)}>
                <IconButton color={`greySecondary`} size={`medium`} variant={"outlined"} onClick={onClickClose}>
                    <IconClose size={16} />
                </IconButton>
            </Tooltip>
            <Tooltip title={i18n.t(`common::label::Save`, `Save`)}>
                <IconButton
                    color={submitDisabled ? `greySecondary` : `primary`}
                    size={`medium`}
                    variant={"outlined"}
                    disabled={submitDisabled}
                    onClick={onClickSubmit}
                    loading={submitPending}
                >
                    <IconSave size={16} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};

export default EditSubmitButtonGroup;
